<template>
  <a-drawer
    :title="`Editar ticket #${ticket.id}`"
    placement="right"
    width="480"
    :visible="visible"
    destroy-on-close
    @close="handleCloseDrawer"
  >
    <p>Edita las propiedades del ticket a continuación:</p>

    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      v-model:value="tags"
      :options="options"
      mode="tags"
      placeholder="Seleccione"
      style="width: 100%"
    />

    <div class="drawer__footer--fixed">
      <div>
        <a-button class="button__drawer--footer" @click="handleCloseDrawer"> Cancelar </a-button>
        <a-button class="button__drawer--footer" type="primary" @click="handleSave">
          Guardar Cambios
        </a-button>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { message } from "ant-design-vue";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    ticket: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();

    const tagsData = computed(() => store.getters["getTags"]);
    const preselectedTags = props.ticket.tags.map((tag) => tag.id);

    const tags = ref(preselectedTags);

    const options = tagsData.value.map((tag) => ({
      value: tag.id,
      label: tag.name,
      disabled: tag.is_permanent,
    }));

    const handleSave = () => {
      const payload = {
        ticketId: props.ticket.id,
        tagsId: [...tags.value],
      };

      store.dispatch("editTicketTags", payload);
      handleCloseDrawer();
      message.success("Se han guardado los cambios correctamente");
    };

    const handleCloseDrawer = () => {
      emit("close-drawer");
    };

    return {
      tags,
      options,
      handleSave,
      handleCloseDrawer,
    };
  },
};
</script>

<style lang="sass" scoped>
p
  color: $gray-8

.drawer__footer--fixed
  bottom: 0
  width: 100%
  border-top: 1px solid $gray-4
  padding: 10px 16px
  left: 0
  background: $white
  border-radius: 0 0 4px 4px
  margin-right: 10px
  position: absolute
  display: flex
  justify-content: flex-end
  align-items: center
  z-index: 1

.button__drawer--footer
  margin-left: 8px
</style>
